import React from "react";
import "./menuItemCardContainer.css";
export var MenuItemCardContainer = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: ["radix-menu-item-card-container", className].filter(Boolean).join(" ") }, children));
};
